'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasePatternFactory = require('../lib/BasePatternFactory');

var _BasePatternFactory2 = _interopRequireDefault(_BasePatternFactory);

var _MobileUARegex = require('../regex/MobileUARegex');

var _MobileUARegex2 = _interopRequireDefault(_MobileUARegex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _BasePatternFactory2.default)({
  name: 'MobileUA',
  validator: function validator(input) {
    return _MobileUARegex2.default.test(input);
  }
});
module.exports = exports['default'];